import styles from "./readMore.module.css"

export default function ReadMore({preview, more, id}){

    return (
        <>
            <p className="narrow">{preview}<span id={`${styles.dots + id}`}>...</span><span id={`${styles.more + id}`} className={styles.more}>{more}</span></p>
            <p className={`narrow start-text underline ${styles.readMore}`} id={`${styles.readMore + id}`} onClick={() => toggleReadMore(id)}>Mehr lesen...</p>
        </>
    )
}

function toggleReadMore(id) {
    var dots = document.getElementById(styles.dots + id);
    var moreText = document.getElementById(styles.more + id);
    var btnText = document.getElementById(styles.readMore + id);

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Mehr lesen...";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Weniger lesen...";
        moreText.style.display = "inline";
    }
}